import script from "./role.vue?vue&type=script&setup=true&lang=js"
export * from "./role.vue?vue&type=script&setup=true&lang=js"

import "./role.vue?vue&type=style&index=0&id=7f8a0b94&lang=scss"

const __exports__ = script;

export default __exports__